import { useDataProvider } from 'react-admin';
import { useQuery } from 'react-query';

const useGetPlatformUserGeneralData = (id) => {
  const dataProvider = useDataProvider();
  const query = useQuery(['getPlatformUserGeneralData', id], () => {
    if (id)
      return dataProvider
        .getPlatformUserGeneralData(id)
        .then(({ data }) => data);
  });

  return query;
};

export default useGetPlatformUserGeneralData;
